export var IdErrorCore;
(function (IdErrorCore) {
    IdErrorCore["UnhandledErrors"] = "UnhandledErrors";
    IdErrorCore["TextErrors"] = "TextErrors";
    IdErrorCore["CoopInvitePlayerErrors"] = "CoopInvitePlayerErrors";
})(IdErrorCore || (IdErrorCore = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdErrorCore.ts
// module id = 144
// module chunks = 3